import type {Hit} from "algoliasearch/lite";
import type {Practice} from "./PracticesMapContainer.tsx";
import {AdvancedMarker, AdvancedMarkerAnchorPoint, useMap} from "@vis.gl/react-google-maps";
import {actions, useApp} from "../providers/AppProvider.tsx";
import {useEffect, useMemo, useState} from "react";
import {getPixelPoint} from "../lib/utils.ts";
import {trackPracticeClick} from "../lib/algolia-insights.ts";
import type {GeoHit} from "instantsearch.js";


const PracticePin = ({practice}: { practice: Practice }) => {
    const {state} = useApp();

    const [isActive, setIsActive] = useState(false);

    const isElite = useMemo(() => practice.status === 'Elite', [practice])

    useEffect(() => {
        if (practice.id === state.selectedPractice?.id) {
            setTimeout(() => {
                setIsActive(true);
            }, state.selectedPractice.noDelay ? 0 : 800)
        } else {
            setIsActive(false);
        }
    }, [practice.id, state.selectedPractice?.id, state.selectedPractice?.noDelay])


    if (isActive) {
        return <img className={"map-pin-active"} alt={""}
                    src={`${import.meta.env.PROD ? `https://${import.meta.env.BASE_URL}` : ''}/assets/markers/active-marker.png`}
                    width={50}/>
    }

    return isElite ?
        <img alt={""}
             src={`${import.meta.env.PROD ? `https://${import.meta.env.BASE_URL}` : ''}/assets/markers/idle-marker.png`}
             width={32}/>
        : <img alt={""}
               src={`${import.meta.env.PROD ? `https://${import.meta.env.BASE_URL}` : ''}/assets/markers/idle-marker.png`}
               width={32}/>
}

const PracticesMarkers = ({practices}: { practices: Hit<Practice>[] }) => {

    const {state, dispatch} = useApp();

    const map = useMap()

    return (
        <>
            {practices.map((practice) => (
                <AdvancedMarker
                    onClick={async (ev) => {
                        dispatch(actions.setSelectedPractice({...practice, noDelay: true}));
                        if (map && ev.latLng) {
                            const markerPixel = getPixelPoint(map, ev.latLng)

                            if (
                                markerPixel &&
                                (
                                    markerPixel?.x < 600
                                    || (window.innerHeight - markerPixel.y) < 50
                                    || markerPixel && markerPixel.y < 50
                                    || ((window.innerWidth - state.options.practiceListWidth) - markerPixel.x) < 50
                                )
                            ) {
                                if (state.isMobileDevice) {
                                    map.panTo(practice._geoloc)
                                    map.panBy(0, 30)
                                } else {
                                    map.setValues({
                                        'autoPan': true,
                                    })
                                    map.setCenter(practice._geoloc)
                                    map.panBy(-150, 0)
                                }
                            }

                        }
                        trackPracticeClick(practice as GeoHit<Practice>);
                    }}
                    zIndex={(practice.id === state.selectedPractice?.id || practice.status === 'Elite') ? 2 : 1}
                    key={practice.id}
                    anchorPoint={practice.status === 'Elite' ? AdvancedMarkerAnchorPoint.CENTER : AdvancedMarkerAnchorPoint.BOTTOM_CENTER}
                    position={practice._geoloc}>
                    <PracticePin practice={practice}/>
                </AdvancedMarker>
            ))}
        </>
    )
}
export default PracticesMarkers